<script lang="ts">

import { defineComponent } from 'vue'

import AsyncIcon from '@/components/atoms/AsyncIcon.vue'
import { useStoreSnapshot } from '@/webgl/composables/useStoreSnapshot'

import CtaComponent from '../atoms/CtaComponent.vue'

export default defineComponent({
  name: 'TheHeader',
  components: { AsyncIcon, CtaComponent },
  setup () {
    const { hasSnapped, snapped } = useStoreSnapshot()

    return {
      hasSnapped,
      snapped
    }
  }
})
</script>

<template>
  <header class="header absolute top-0 left-0 flex flex-row justify-end w-full bg-transparent p-4 <sm:p-2">
    <div class="wrapper w-full flex flex-row justify-between items-center">
      <div class="w-20 max-w-20 flex flex-row justify-center">
        <button v-show="snapped" :disabled="!snapped" class="w-fit h-fit p-4" @click="hasSnapped(false)">
          <AsyncIcon name="arrow" class="text-white" />
        </button>
      </div>
      <AsyncIcon name="logo" class="h-20 w-auto justify-self-center" />

      <div class="w-20 max-w-20 flex flex-row justify-center">
        <CtaComponent class="body-1 border-none w-fit h-fit p-4 uppercase text-white">
          EN
        </CtaComponent>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.header {
  z-index: $z-header;
}
</style>
